<template>
  <dashboard-layout>
    <div class="container-fluid">
      <div class="col-md-6">
                    <router-link to="/dashboard" class="icon text-gray-600">
                    <i class="fas fa-arrow-left"></i> Back
                    </router-link>
                </div><br>
  
          <div>
            <h5 class="m-0 font-weight-bold text-dark">Create Notification</h5>
            <h8 class="m-0 text-dark">
              Here you can create notifications and send them to swwipe users as in-app notifications.
            </h8>
          </div><br>
      <div class="card shadow light mb-4">
        <div class="card-body custom-card-body"><br>
          <form @submit.prevent="previewNotification">
            
            <div class="mb-5">
              <label for="notificationSubject" class="text-black" style="margin-bottom: 1px;" >Notification Subject<label class="text-danger">*</label></label>
              <input
                type="text"
                class="form-control"
                id="notificationSubject"
                style="height: 50px; width: 600px;"
                placeholder="Type Here....."
                v-model="notificationSubject"
                required
                @input="updateCharacterCount"
              />
            </div>
           
            <div class="mb-3">
              <label for="message" class="text-black" style="margin-bottom: 1px;">Message<label class="text-danger">*</label></label>
              <textarea
                class="form-control"
                id="message"
                style="height: 218px; width: 600px;"
                placeholder="Type Here....."
                v-model="message"
                required
                maxlength="100"
                @input="updateCharacterCount"
              ></textarea>
              <small class="text-muted text-right">{{ characterCount }}/100</small>
            </div>
            <button type="submit" class="custombutton2 custombutton2-user custombutton2-block" style="margin-top: 30px; margin-bottom: 30px;">Send</button>
          </form>
          <div class="modal-overlay" v-show="showPreviewModal">
        <Modal class="custom-modal" v-show="showPreviewModal">
        
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title m-0 font-weight-bold text-dark">Notification Preview</h5>
                <button type="button" class="close" @click="showPreviewModal = false">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p><strong>Subject:</strong> {{ notificationSubject }}</p>
                <p><strong>Message:</strong> {{ message }}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click="showPreviewModal = false">Cancel</button>
                <button type="button" class="btn btn-dark" @click="sendNotification" :disabled="loading">
                  <span v-if="loading">
                  <i class="fa fa-spinner fa-spin"></i> Sending
                </span>
                <span v-else>Confirm & Send</span>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
    </div>
    </div>
  </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/components/DashboardLayout.vue';
import axios from 'axios';

let logData; 

export default {
  name: 'push-notification',

  components: {
    DashboardLayout,
  },

  data() {
    return {
      notificationSubject: '',
      message: '',
      characterCount: 0,
      showPreviewModal: false,
      loading: false,
    };
  },

  methods: {
    updateCharacterCount() {
      this.characterCount = this.message.length;
    },

    previewNotification() {
      this.showPreviewModal = true; 
    },

    async sendNotification() {
      this.loading = true;
      
      const notificationData = {
        title: this.notificationSubject, 
        message: this.message, 
      };

     
      try {
        const response = await axios.post(this.$config.INAPPNOTIFICATION_ENDPOINT, notificationData, {
          headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIyMjEyIiwiZW1haWwiOiJhYmR1bGxhaGVuYTkwMEBnbWFpbC5jb20iLCJqdGkiOiJhMTRiMjE2ZS0wNGQ5LTRkOTctYjhjZC04MzJlNjdmOWNmYWIiLCJidXNpbmVzc2VzIjoiW3tcIklkXCI6MjA4NixcIk5hbWVcIjpcImsmayBzb2x1dGlvbnNcIixcIlRpZXJMZXZlbFwiOlwiVGllcl8yXCIsXCJUaWVyTGV2ZWxBbGlhc1wiOlwiU3RhbmRhcmRcIixcIkxvY2F0aW9uc1wiOlt7XCJJZFwiOjEzNzAsXCJBZGRyZXNzXCI6XCI1MiB0b255IEFuZWdib2RlIHN0clwiLFwiTG9jYXRpb25OYW1lXCI6XCJcIixcIkFjY291bnROdW1iZXJcIjpcIjAyNTEyNTkyODhcIixcIkFjY291bnROYW1lXCI6XCJBQkRVTExBSEkgSVNNQUlMXCIsXCJCYW5rQ29kZVwiOlwiMDM1XCIsXCJTdGF0ZVwiOlwiTGFnb3NcIixcIkxHQVwiOlwiRXRpIE9zYVwifV19XSIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTcwMTY0MDM2NiwiZXhwIjoxODYyMzQ0MzY2LCJpYXQiOjE3MDE2NDAzNjYsImlzcyI6Imh0dHBzOi8vd3d3LnNlY3VyaXR5LmNvbSIsImF1ZCI6Imh0dHBzOi8vd3d3LnNlY3VyaXR5LmNvbSJ9.flduUzoHOxztkBnaGy5Xw1ILaJpgUCXA-rji13tkt0w', // Replace with your token
          },
        });

      
        if (response.status === 200) {


          logData = {
  UserID: sessionStorage.getItem('userId'),
  FName: sessionStorage.getItem('firstName'),
  LName: sessionStorage.getItem('lastName'),
  Email: sessionStorage.getItem('email'),
  Role: sessionStorage.getItem('role'),
  Department: sessionStorage.getItem('department'),
  ActionType: 'Push Notification',
  Activity: `${sessionStorage.getItem('firstName')} has pushed notification to all Swwipe Users`,
  Category: 'Notification',
  Timestamp: new Date().toISOString()
};

const token = sessionStorage.getItem('token');
const headers = {
  'Authorization': `Bearer ${token}`,
};


axios.post(this.$config.ADDACTIVITYLOG_ENDPOINT, logData, { headers })
  .then(response => {
   
    console.log(response);
  })
  .catch(error => {
   
    console.error(error);
    this.$toast.open({
        message: error,
        type: 'error', 
        duration: 3000, 
      });
  });

          this.$toast.open({
            message: 'Notification sent successfully!',
            type: 'success',
            duration: 3000,
          });
          this.notificationSubject = '';
          this.message = '';
          this.loading = false;
          this.showPreviewModal = false;

          

        } else {
          this.loading = false;
          this.$toast.open({
            message: 'Failed to send the notification.',
            type: 'error',
            duration: 3000,
          });
        }
      } catch (error) {
        
        console.error('Error sending notification:', error);
        this.loading = false;
        this.$toast.open({
          message: 'Failed to send the notification: '+ error,
          type: 'error',
          duration: 3000,
        });
      }
    },

  },
};
</script>

<style>

.custom-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custombutton2:hover {
  background-color: #8C6DFF;
  color: #8C6DFF;
}

.custombutton2 {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #6F48FF;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.35rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

form.user .custombutton2-user {
  background-color: #8C6DFF;
  font-size: 0.8rem;
  border-radius: 10rem;
  padding: 0.75rem 1rem;
}





.custombutton2:hover {
  color: #ffffff;
}


.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #8C6DFF;
  border-color: #8C6DFF;
}

.custombutton2-block {
  display: block;
  width: 100%;
}

.custombutton2-block + .custombutton2-block {
  margin-top: 0.5rem;
}

input[type="submit"].custombutton2-block,
input[type="reset"].custombutton2-block,
input[type="button"].custombutton2-block {
  width: 100%;
}





</style>
